import { formatTextWithBreak } from "@/utils/helpers";
import { splitAmount } from "@/func/priceNotation";

const ProductPriceBlock = ({ priceObject, oldPrice, product, isBestValue, isBestSeller, bundledPrices, bundle }) => {
  let displayNumber, displayCents, displayHasCents, displaySymbol, displaySymbolLeft;
  const decimalSeparator = priceObject?.decimalSeparator ?? ".";
  const totalLabel = window.post_template.checkout_v4_products.tr_checkout_v4_products_totalLabel;
  const eachLabel = window.post_template.checkout_v4_products.tr_checkout_v4_products_eachLabel;
  const bestSellerLabel = window?.post_template?.checkout_v4_products?.tr_checkout_v4_products_bestSellerLabel;
  const bestValueLabel = window?.post_template?.checkout_v4_products?.tr_checkout_v4_products_bestValueLabel;

  let bestValueContent = null;
  let bestSellerContent = null;
  if (isBestValue && product?.tr_best_value_status) {
    // old from product pack
    bestValueContent = formatTextWithBreak(product.tr_best_value_status?.toUpperCase());
  } else if (bestValueLabel) {
    // new approach from template
    bestValueContent = formatTextWithBreak(bestValueLabel?.toUpperCase());
  }
  if (isBestSeller && product?.status) {
    // old from product pack
    bestSellerContent = formatTextWithBreak(product.status?.toUpperCase());
  } else if (bestSellerLabel) {
    // new approach from template
    bestSellerContent = formatTextWithBreak(bestSellerLabel?.toUpperCase());
  }

  if (bundledPrices) {
    // The bundled total is computed here rather than parsed off a formatted price, so it has to be
    // split on the currency's own notation to keep its thousands separator and cents in step.
    const { whole, cents } = splitAmount(product.amount * product.price, decimalSeparator);
    displayNumber = whole;
    displayCents = cents;
    displayHasCents = priceObject?.hasCents;
    displaySymbol = priceObject?.symbol;
    displaySymbolLeft = priceObject?.symbolLeft;
  } else {
    displayNumber = priceObject?.number;
    displayCents = priceObject?.cents;
    displayHasCents = priceObject?.hasCents;
    displaySymbol = priceObject?.symbol;
    displaySymbolLeft = priceObject?.symbolLeft;
  }

  return (
    <div
      className={`${bundle ? "productPacItem__priceBlock__bundlesContainer" : "productPacItem__priceBlock__container"}`}
    >
      <div data-testid="product-price-old" className="productPacItem__priceBlock__oldPrice">
        {oldPrice && oldPrice}
      </div>
      <div className="productPacItem__priceBlock__mainPriceBlock">
        {displaySymbolLeft && <sup>{displaySymbol}</sup>}
        <div data-testid="product-price" className="productPacItem__priceBlock__price">
          {displayNumber !== undefined && displayNumber}
        </div>

        <div className="productPacItem__priceBlock__centsBlock">
          <div data-testid="product-price-cents" className="productPacItem__priceBlock__cents">
            {displayHasCents && `${decimalSeparator}${displayCents}`}
          </div>

          <div
            className={`productPacItem__priceBlock__each
                ${
                  displayHasCents
                    ? "productPacItem__priceBlock__each--with-cents"
                    : "productPacItem__priceBlock__each--without-cents"
                }`}
          >
            {bundledPrices ? totalLabel : eachLabel}
          </div>
        </div>
        {!displaySymbolLeft && (
          <div className="productPacItem__priceBlock" style={{ marginInlineStart: "2px" }}>
            <sup>{displaySymbol}</sup>
          </div>
        )}
      </div>
      {isBestSeller && <div className="productPacItem__priceBlock__labelTag">{bestSellerContent}</div>}
      {isBestValue && <div className="productPacItem__priceBlock__bestValueTag">{bestValueContent}</div>}
    </div>
  );
};

export default ProductPriceBlock;
